export function emptyJobCard() {
    return {id: 0, total: 0, discount: 0, customer_afforded: 0, ftotal: 0, vat: 0, paid: 0,
        client: {}, rows: [], _cars: [], images: [], status: [], payments: [], expense: [],
        tem_expense: [], cost_expense: [], worker_assignments: [], rowType: {}};
}

export function cardRowGroup(groups, value) {
    const group = groups && groups[`rowType_${value}`];
    return {options: group && group.options && typeof group.options === 'object' ? group.options : {},
        items: group && Array.isArray(group.items) ? group.items : [],
        total: Number.isFinite(Number(group && group.total)) ? Number(group && group.total) : 0};
}

export function jobCardViewData(body, expectedId) {
    const card = body && body.results && body.results.data;
    if (!body || !body.error || Number(body.error.number) !== 200 || !card ||
        !Number.isInteger(Number(card.id)) || Number(card.id) <= 0 || Number(card.id) !== Number(expectedId)) {
        const error = new Error('job_card_not_available');
        error.notFound = !!(body && body.error && Number(body.error.number) === 404);
        throw error;
    }
    const result = {...emptyJobCard(), ...card};
    for (const key of ['rows', '_cars', 'images', 'status', 'payments', 'expense', 'tem_expense', 'cost_expense', 'worker_assignments']) {
        if (!Array.isArray(result[key])) result[key] = [];
    }
    result.client = card.client && !Array.isArray(card.client) && typeof card.client === 'object' ? card.client : {};
    result.rowType = card.rowType && !Array.isArray(card.rowType) && typeof card.rowType === 'object' ? card.rowType : {};
    for (const key of ['total', 'discount', 'customer_afforded', 'ftotal', 'vat', 'paid']) {
        result[key] = Number.isFinite(Number(result[key])) ? Number(result[key]) : 0;
    }
    return {card: result, terms: Array.isArray(body.results.terms) ? body.results.terms : []};
}
